import axios from "axios";
import { api } from '../api';
import Vue from "vue";

export const state = {
  instruments: [{id: 1}, {id: 2}],
  history: [],
  sideView: '',
  idSterilizare: undefined,
  search: '',
  searchHistory: '',
  error: ''
}

export const mutations = {
  SET_INSTRUMENTS (state, data) {
    state.instruments = data;
  },
  SAVE_INSTRUMENT (state, instrument) {
    state.instruments.push(instrument);
  },
  UPDATE_INSTRUMENT (state, data) {
    const index = state.instruments.findIndex(instrument => instrument._id === data._id);
    if (index !== -1) {
      // Use Vue.set to ensure reactivity
      Vue.set(state.instruments, index, data);
    }
  },
  SET_SIDE_VIEW (state, view) {
    state.sideView = view;
    state.idSterilizare = undefined;
  },
  SET_ID_STERILIZARE (state, id) {
    state.idSterilizare = id;
  },
  DELETE_INSTRUMENT (state, _id) {
    const index = state.instruments.findIndex(obj => obj._id === _id);
    state.instruments.splice(index, 1);
  },
  SEARCH_INSTRUMENT (state, value) {
    state.search = value;
  },
  SEARCH_HISTORY (state, value) {
    state.searchHistory = value;
  },
  SET_HISTORY (state, data) {
    state.history = data;
  },
  SET_ERROR (state, error) {
    state.error = error;
  }
}

export const actions = {
  async get_instruments ({ commit }) {
    try {
      const { data } = await axios.get(api.instruments);
      commit('SET_INSTRUMENTS', data);
    } catch (err) {
      console.log(err)
    }
  },
  async create_instrument ({ commit }, payload) {
    try {
      const { data } = await axios.post(api.instruments, payload);
      commit('SAVE_INSTRUMENT', data);
      commit('SET_SIDE_VIEW', '');
    } catch (err) {
      console.log(err)
    }
  },
  async update_instrument ({ commit }, payload) {
    try {
      const { data } = await axios.put(api.instruments, payload);
      commit('UPDATE_INSTRUMENT', data);
      commit('SET_SIDE_VIEW', '');
    } catch (err) {
      console.log(err)
    }
  },
  async sterilyze_instrument ({ state, commit }, payload) {
    try {
      await axios.post(api.sterylize, payload);
      commit('SET_SIDE_VIEW', '');
      commit('SET_ERROR', '');
      payload.clbk && payload.clbk();
    } catch (err) {
      commit('SET_ERROR', err.response?.data || err.response || err);
    }
  },
  async get_new_id_sterilizare ({ commit }) {
    try {
      const { data } = await axios.get(`${api.sterylize}/get-id`);
      commit('SET_ID_STERILIZARE', data.id);
    } catch (err) {
      console.log(err)
    }
  },
  async delete_instrument ({ commit }, _id) {
    try {
      await axios.delete(`${api.instrument}/${_id}`);
      commit('DELETE_INSTRUMENT', _id);
      commit('SET_SIDE_VIEW', '');
    } catch (err) {
      console.log(err)
    }
  },
  async get_history_by_id_instrument ({ commit }, _id) {
    try {
      const { data } = await axios.get(`${api.instrument}/get-history/${_id}`);
      commit('SET_HISTORY', data);
    } catch (err) {
      console.log(err)
    }
  }
}

export const getters = {
  instruments: state => {
    let results = state.instruments.slice();
    if (!!state.search) {
      results = state.instruments
        .filter(o => o.name?.toLowerCase()?.startsWith(state.search));
    }
    return results;
  },
  history: state => {
    let results = state.history.slice();
    if (!!state.searchHistory) {
      results = filterDataByDate(results, state.searchHistory)
    }
    return results;
  }
}

function filterDataByDate (data, dateString) {
  // Return all data if no date is provided
  if (!dateString) {
    return data;
  }

  // Convert the input date string to start and end timestamps of that day
  const selectedDate = new Date(dateString);

  // Set time to beginning of day (00:00:00)
  const startOfDay = new Date(selectedDate);
  startOfDay.setHours(0, 0, 0, 0);
  const startTimestamp = startOfDay.getTime();

  // Set time to end of day (23:59:59.999)
  const endOfDay = new Date(selectedDate);
  endOfDay.setHours(23, 59, 59, 999);
  const endTimestamp = endOfDay.getTime();

  // Filter data where date timestamp falls within the day
  return data.filter(item => {
    return item.date >= startTimestamp && item.date <= endTimestamp;
  });
}
